import { CHAINS, getChain } from "./chains";

// Stablecoin token registry (USDT / USDC) per chain.
export const TOKENS = {
  eth: [
    { symbol: "USDT", name: "Tether USD", address: "0xdAC17F958D2ee523a2206206994597C13D831ec7", decimals: 6, price: "USDT", std: "erc20" },
    { symbol: "USDC", name: "USD Coin", address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48", decimals: 6, price: "USDC", std: "erc20" },
  ],
  bsc: [
    { symbol: "USDT", name: "Tether USD", address: "0x55d398326f99059fF775485246999027B3197955", decimals: 18, price: "USDT", std: "erc20" },
    { symbol: "USDC", name: "USD Coin", address: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d", decimals: 18, price: "USDC", std: "erc20" },
  ],
  polygon: [
    { symbol: "USDT", name: "Tether USD", address: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F", decimals: 6, price: "USDT", std: "erc20" },
    { symbol: "USDC", name: "USD Coin", address: "0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359", decimals: 6, price: "USDC", std: "erc20" },
  ],
  tron: [
    { symbol: "USDT", name: "Tether USD", address: "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t", decimals: 6, price: "USDT", std: "trc20" },
    { symbol: "USDC", name: "USD Coin", address: "TEkxiTehnzSmSe2XqrBj4w32RUN966rdz8", decimals: 6, price: "USDC", std: "trc20" },
  ],
  sol: [
    { symbol: "USDT", name: "Tether USD", address: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB", decimals: 6, price: "USDT", std: "spl" },
    { symbol: "USDC", name: "USD Coin", address: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v", decimals: 6, price: "USDC", std: "spl" },
  ],
};

export const tokensFor = (chainId) => TOKENS[chainId] || [];

// Flat asset list: native coin + its tokens, for every chain.
export function buildAssets() {
  const list = [];
  CHAINS.forEach((c) => {
    list.push({
      id: c.id, chain: c.id, kind: "native", symbol: c.symbol, name: c.name,
      decimals: c.decimals, priceKey: c.price, color: c.color,
    });
    tokensFor(c.id).forEach((t) => {
      list.push({
        id: `${c.id}:${t.symbol}`, chain: c.id, kind: "token", symbol: t.symbol,
        name: `${t.name}`, decimals: t.decimals, priceKey: t.price, color: c.color, token: t,
      });
    });
  });
  return list;
}

// Assets available to send on a given chain (native first, then tokens)
export function assetsForChain(chainId) {
  const c = getChain(chainId);
  const native = { id: chainId, chain: chainId, kind: "native", symbol: c.symbol, name: c.name, decimals: c.decimals, priceKey: c.price, color: c.color };
  const toks = tokensFor(chainId).map((t) => ({
    id: `${chainId}:${t.symbol}`, chain: chainId, kind: "token", symbol: t.symbol, name: t.name,
    decimals: t.decimals, priceKey: t.price, color: c.color, token: t,
  }));
  return [native, ...toks];
}
